
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class LogoutDialog extends Vue {
    openDialog: boolean = false;

    logout(): void {
        this.$store.commit("Auth/setAuthToken",'');
        this.$ports.auth.logout();
    }
}
